import type { Instruction } from "@atlaskit/pragmatic-drag-and-drop-hitbox/tree-item";

/**
 * Custom tree drop indicator using Tailwind classes.
 * Replaces Atlaskit's DropIndicator which depends on @compiled/react CSS
 * that doesn't load properly through Vite's bundling pipeline.
 */
export function TreeDropIndicator({
	instruction,
}: { instruction: Instruction }) {
	if (instruction.type === "instruction-blocked") {
		return null;
	}

	if (instruction.type === "make-child") {
		return (
			<div className="absolute inset-0 rounded-lg border-2 border-brand-primary pointer-events-none" />
		);
	}

	const indent =
		instruction.type === "reparent"
			? instruction.desiredLevel * instruction.indentPerLevel
			: instruction.currentLevel * instruction.indentPerLevel;

	const isAbove = instruction.type === "reorder-above";

	return (
		<div
			className={`absolute left-0 right-0 flex items-center pointer-events-none ${isAbove ? "top-0" : "bottom-0"}`}
			style={{ paddingLeft: indent }}
		>
			<div className="size-2 rounded-full bg-brand-primary shrink-0 -ml-1" />
			<div className="h-0.5 bg-brand-primary flex-1 rounded-full" />
		</div>
	);
}
